import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import paths from '../paths';
import { createLazyComponent, createRoute } from 'constants/utils';
const AccountLayout = lazy(() => import('../../components/pages/account/AccountLayout/AccountLayout'));
const RecentActivity = lazy(() => import('../../components/pages/account/RecentActivity/RecentActivity'));
const Account = lazy(() => import('../../components/pages/account/Account/Account'));
const Notifications = lazy(() => import('../../components/pages/account/notifications/Notifications'));
const TestOrders = lazy(() => import('../../components/pages/account/AccountTestOrders/AccountTestOrders'));

export const accountRoutes = (abilities) => {
  return {
    path: paths.getAccountLayout,
    element: createLazyComponent(AccountLayout),
    children: [
      {
        index: true,
        element: (
          <Navigate
            replace={true}
            to={paths.recentActivities}
          />
        ),
      },
      createRoute(paths.recentActivities, RecentActivity),
      (abilities?.settings?.account?.read ?? false) && createRoute(paths.account, Account),
      (abilities?.settings?.notification?.read ?? false) && createRoute(paths.notification, Notifications),
      (abilities?.orders?.order?.read ?? false) && createRoute(paths.accountTestOrders, TestOrders),
    ],
  };
};
